import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { useDesktopColors } from '@/constants/residents/desktop/color';
import { Radio } from '@/components/common/Radio';

interface PaymentRadioOptionProps {
  selected: boolean;
  onPress: () => void;
  label: string;
  value?: string;
  rightComponent?: React.ReactNode;
  style?: any;
}

export const PaymentRadioOption: React.FC<PaymentRadioOptionProps> = ({
  selected,
  onPress,
  label,
  value,
  rightComponent,
  style,
}) => {
  const DESKTOP_COLORS = useDesktopColors();
  return (
    // The row's `rightComponent` (the amount field on desktop) sits inside this
    // touchable, so the default press fade (0.2) would wash out the field's own
    // text and border for as long as the mouse is down, including the whole of
    // a drag to select text. The radio's state change is the press feedback.
    <TouchableOpacity style={[styles.optionRow, style]} onPress={onPress} activeOpacity={1}>
      <View style={styles.optionLeft}>
        <Radio selected={selected} />
        <Text style={[styles.optionLabel, { color: DESKTOP_COLORS.TEXT_PRIMARY }]}>{label}</Text>
      </View>
      {value && (
        <Text style={[styles.optionValue, { color: DESKTOP_COLORS.TEXT_PRIMARY }]}>{value}</Text>
      )}
      {rightComponent}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  optionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
  },
  optionLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  optionLabel: {
    fontSize: 16,
    marginRight: 8,
    fontWeight: '600',
    marginLeft: 12,
  },
  optionValue: {
    fontSize: 16,
    fontWeight: '600',
  },
});
